import React from 'react'
import {
  Container,
  Box,
  Text,
  Image,
  SimpleGrid,
  Input,
  Textarea,
  Button,
  Flex,
} from '@chakra-ui/react'
import About from '../../../../../assets/pngs/about.jpg'
import { HotelSignal, Shower, Grid } from '../../../../../assets/svgs'
import styled from 'styled-components'

const ExtraCardWrapper = styled.div`
  .card_icon {
    margin-right: 10px;
  }
`

const ExtraInfoCard = ({ card = [], isGreen }) => {
  return (
    <Box
      as={ExtraCardWrapper}
      display="flex"
      flexFlow="column"
      borderRadius="25px"
      boxShadow="0px 32px 34px rgba(0, 0, 0, 0.133714)"
      border={isGreen ? '3px solid #FFFFFF' : '3px solid #83B53C'}
      background="#FFFFFF"
    >
      <Image
        src={card.file.file.url}
        alt="about_img"
        width="100%"
        objectFit="cover"
        height="291px"
        borderRadius="20px 20px 0px 0px"
        overflow="hidden"
        marginBottom="22px"
      />
      <Box display="flex" flexFlow="column" padding="0px 33px">
        <Text
          as={'h3'}
          fontSize="22px"
          fontWeight="bold"
          color="#6A6565"
          marginBottom="6px"
          whiteSpace="nowrap"
          width="100%"
          overflow="hidden"
          textOverflow="ellipsis"
        >
          {card.title}
        </Text>
        {card?.description?.description && (
          <Text
            fontSize="14px"
            color="#1E3240"
            fontWeight="bold"
            marginBottom="9px"
            width="100%"
            whiteSpace="nowrap"
            overflow="hidden"
            textOverflow="ellipsis"
          >
            {`Location: ${card.description.description}`}
          </Text>
        )}
        <Text
          as={'h4'}
          fontSize="18px"
          fontWeight="bold"
          color="#83B53C"
          marginBottom="24px"
          width="100%"
          whiteSpace="nowrap"
          overflow="hidden"
          textOverflow="ellipsis"
        >
          {`Price: ${card.subtitle}`}
        </Text>
      </Box>
      {card.actions.length !== 0 ? (
        <SimpleGrid
          columns={{ base: 3 }}
          height="66px"
          borderTop="1px solid #E4E4E4"
        >
          {(card?.actions || []).map((item, index) => (
            <Box key={index} display="contents">
              <Box display="flex" justifyContent="center" alignItems="center">
                <HotelSignal className="card_icon" />
                <Text>{item.bed}</Text>
              </Box>
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                borderLeft="1px solid #E4E4E4"
                borderRight="1px solid #E4E4E4"
              >
                <Shower className="card_icon" />
                <Text>{item.shower}</Text>
              </Box>
              <Box display="flex" justifyContent="center" alignItems="center">
                <Grid className="card_icon" />
                <Text>{item.artBoard}</Text>
              </Box>
            </Box>
          ))}
        </SimpleGrid>
      ) : null}
    </Box>
  )
}

export default ExtraInfoCard
